<template>
  <div>
    <SCThreeCheckbox
      :id="htmlId"
      label-text="Invert Main Price Scale"
      :checkbox-value="chartStore.isMainPriceScaleInverted"
      @update:checkbox-value="handleCheckboxValueChanged"
      :is-dark-font="true"
      :is-square="true"
      :is-double-spaced="true"
    />
  </div>
</template>

<script lang="ts" setup>
  import { toRefs } from 'vue';
  import { useChartStore } from '@/stores/chartStore';
  import { updateIsMainPriceScaleInverted } from '@/composables/updateIsMainPriceScaleInverted';
  import SCThreeCheckbox from '@/components/checkboxes/SCThreeCheckbox.vue';

  const chartStore = useChartStore();
  const props = defineProps<{
    htmlId: string;
  }>();
  const { htmlId } = toRefs(props);

  function handleCheckboxValueChanged(shouldMainPriceScaleNowBeInverted: boolean) {
    updateIsMainPriceScaleInverted(shouldMainPriceScaleNowBeInverted);
  }
</script>
